import h from 'react-hyperscript';

import pkgJson from '../../../package.json';

const { config: { rootUri: { host: tld }, fullName: company } } = pkgJson;

/* istanbul ignore next */
const { REACT_APP_ENV_PREFIX = '' } = process.env;
let PREFIX = 'www';

/* istanbul ignore next */
if (REACT_APP_ENV_PREFIX) {
  PREFIX = REACT_APP_ENV_PREFIX.toLowerCase();
}

const host = `${PREFIX}.${tld}`;

const Footer = props => {
  const year = new Date().getFullYear();

  return h('footer.app-footer', [
    h('.footer-copyright', [h('a.copyright', { href: `//${host}` }, company), h('span', ` \u00A9 ${year}`)]),
    h('.footer-legal', [
      h('a.terms-of-service', { target: 'legal', href: `//${host}/terms-of-service` }, 'Terms'),
      ' :: ',
      h('a.privacy-policy', { target: 'legal', href: `//${host}/privacy` }, 'Privacy'),
    ]),
    h('.footer-made-with', [
      'Made with ',
      h('i.fa.fa-heart', { title: 'Love' }),
      ' + ',
      h('i.fa.fa-flask', { title: 'Data science' }),
    ]),
  ]);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js